<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-gray-900/50 backdrop-blur-sm" @click="close"></div>
    
    <!-- Dialog -->
    <div class="relative bg-white rounded-xl shadow-xl overflow-hidden w-full max-w-sm fade-in">
      <div class="p-6 text-center">
        <!-- Icon -->
        <div 
          class="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
          :class="iconBgClass"
        >
          <font-awesome-icon 
            :icon="iconName" 
            class="text-2xl"
            :class="iconClass"
          />
        </div>
        
        <!-- Title -->
        <h3 class="text-lg font-semibold text-gray-900 mb-2">{{ title }}</h3>
        
        <!-- Message -->
        <p class="text-gray-600 mb-6">{{ message }}</p>
        
        <!-- Actions -->
        <div class="flex justify-center space-x-3">
          <button
            @click="close"
            class="btn btn-secondary px-6"
          >
            {{ cancelText }}
          </button>
          <button
            @click="confirm"
            class="btn px-6"
            :class="confirmButtonClass"
          >
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: 'Confirm Action',
    },
    message: {
      type: String,
      default: 'Are you sure you want to proceed?',
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    variant: {
      type: String,
      default: 'danger',
      validator: (value) => ['danger', 'warning', 'primary'].includes(value),
    },
  },
  computed: {
    iconName() {
      switch (this.variant) {
        case 'warning':
          return 'exclamation-triangle'
        case 'primary':
          return 'question-circle'
        default:
          return 'trash'
      }
    },
    iconBgClass() {
      switch (this.variant) {
        case 'warning':
          return 'bg-warning-100'
        case 'primary':
          return 'bg-primary-100'
        default:
          return 'bg-danger-100'
      }
    },
    iconClass() {
      switch (this.variant) {
        case 'warning':
          return 'text-warning-600'
        case 'primary':
          return 'text-primary-600'
        default:
          return 'text-danger-600'
      }
    },
    confirmButtonClass() {
      switch (this.variant) {
        case 'warning':
          return 'bg-warning-600 hover:bg-warning-700 text-white'
        case 'primary':
          return 'btn-primary'
        default:
          return 'bg-danger-600 hover:bg-danger-700 text-white'
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>





